module.exports = [
	{
		"id": 1,
		"title": "creating this site",
		"driveID": "0B_h-DIXAPVoiSzdYVkt1OVF4Z1E",
		"postDate": "2017-07-25",
		"show": true,
		"tags": [
			"react",
			"redux",
			"github-pages"
		]
	},
	{
		"id": 2,
		"title": "chrome dev tools",
		"driveID": "0B_h-DIXAPVoiSlRBSzJYNEdPaEE",
		"postDate": "2017-07-26",
		"show": false,
		"tags": [
			"debugging"
		]
	},
	{
		"id": 3,
		"title": "frontend testing",
		"driveID": "0B_h-DIXAPVoiaEZSUlRiOFBHaFk",
		"postDate": "2017-07-27",
		"show": false,
		"tags": [
			"testing"
		]
	},
	{
		"id": 4,
		"title": "embedded analytics",
		"driveID": "0B_h-DIXAPVoiYVhwNF9ZazZHZ2c",
		"postDate": "2017-07-28",
		"show": false,
		"tags": [
			"bi",
			"analytics"
		]
	},
	{
		"id": 5,
		"title": "Presto",
		"driveID": "0B_h-DIXAPVoiek1oRnlNYXRsaFk",
		"postDate": "2017-07-28",
		"show": false,
		"tags": [
			"db",
			"presto",
			"analytics"
		]
	},
	{
		"id": 6,
		"title": "Druid",
		"driveID": "0B_h-DIXAPVoiQWpYWkplRFhJelE",
		"postDate": "2017-07-28",
		"show": false,
		"tags": [
			"db",
			"druid",
			"analytics"
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/posts.json
// module id = 581
// module chunks = 1